import React from 'react';
import { motion } from 'framer-motion';
const cards = [{
  title: 'Si nunca has hecho filigrana',
  desc: 'Perfecto. El curso está diseñado para acompañarte desde tus primeros pasos.',
  tone: 'bg-fil-card border-fil-beige'
}, {
  title: 'Si ya lo has intentado',
  desc: 'Podrás mejorar tus técnicas, corregir errores, conseguir mejores terminaciones y descubrir nuevas posibilidades creativas.',
  tone: 'bg-fil-sage/15 border-fil-sage/40'
}];
export function BeginnersSection() {
  return <section className="bg-fil-card px-4 sm:px-6 lg:px-8 py-12 sm:py-16" data-id="element-17" data-mp="1o4tahjr0vt9e">
      <div className="max-w-4xl mx-auto" data-id="element-18" data-mp="1o6xdlzh3ko8m">
        <div className="text-center max-w-2xl mx-auto mb-10" data-id="element-19" data-mp="224ly36795td5">
          <span className="inline-block text-[10px] sm:text-xs font-bold uppercase tracking-[0.14em] text-fil-sage-dark mb-4" data-id="element-20" data-mp="1y2r0ocsg004n">
            Pensado para principiantes
          </span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-fil-text leading-tight mb-5" data-id="element-21" data-mp="7se17nbdf2eq">
            No necesitas saber filigrana para comenzar
          </h2>
          <div className="space-y-3 text-base sm:text-lg text-fil-taupe leading-relaxed" data-id="element-22" data-mp="1jp5qyqk4i9kx">
            <p data-id="element-23" data-mp="1onfm515ula6j">
              El curso comienza desde lo más básico: qué papel utilizar, cómo
              preparar las tiras, cómo usar las herramientas y cómo realizar
              tus primeros rollos.
            </p>
            <p data-id="element-24" data-mp="1yds54oy0kvak">
              Después avanzarás progresivamente hasta crear composiciones
              completas y conseguir terminaciones mucho más prolijas.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-5" data-id="element-25" data-mp="27f8gp00kf3gd">
          {cards.map((card, i) => <motion.article key={card.title} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: i * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`rounded-[1.75rem] border p-6 sm:p-8 ${card.tone}`} data-id="element-26" data-mp="2ccrszudpd65o" data-mpi={i}>
              <h3 className="text-lg sm:text-xl font-bold text-fil-text leading-tight mb-3" data-id="element-27" data-mp="exdyrq89n8ex">
                {card.title}
              </h3>
              <p className="text-sm sm:text-base text-fil-text/75 leading-relaxed" data-id="element-28" data-mp="axdjy4h98v7c">
                {card.desc}
              </p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}